"use client";
import { exportUsersTop } from "@/actions";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { UI } from "@/constants";
import { SearchParams } from "@/types";
import { Download } from "lucide-react";
import { useState } from "react";
import { Spinner } from "../ui/spinner";

const size = "50000";

export const ExportUsers = (params: SearchParams) => {
  const [isLoading, setIsLoading] = useState(false);

  const onExport = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const csvText = await exportUsersTop({ ...params, size });

      const blob = new Blob(["\uFEFF", csvText], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "users-top.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button onClick={onExport} variant="outline" size="icon-sm" disabled={isLoading}>
          {isLoading ? <Spinner /> : <Download />}
        </Button>
      </TooltipTrigger>
      <TooltipContent>{UI.tooltips.exportUsers}</TooltipContent>
    </Tooltip>
  );
};
